var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Interface / Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Search",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4864 18.016L14.0455 12.5751C16.5098 9.33574 16.0428 4.74092 12.9771 2.06363C9.91134 -0.61365 5.29547 -0.457726 2.41741 2.42034C-0.460656 5.2984 -0.61658 9.91427 2.0607 12.98C4.73799 16.0457 9.33281 16.5128 12.5722 14.0485L18.013 19.4893C18.4228 19.889 19.0766 19.889 19.4864 19.4893C19.8928 19.0823 19.8928 18.423 19.4864 18.016ZM2.29138 7.91681C2.29138 4.81021 4.80978 2.29181 7.91638 2.29181C11.023 2.29181 13.5414 4.81021 13.5414 7.91681C13.5414 11.0234 11.023 13.5418 7.91638 13.5418C4.8113 13.5381 2.29505 11.0219 2.29138 7.91681Z",
    fill: "#A5A5A4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.223e008ddea3b25456fb7ba71bc92ee0.svg";
export { ForwardRef as ReactComponent };